import { render } from "./BuyWithConfidenceShoutPanel.vue?vue&type=template&id=3a2b6e1e&scoped=true"
const script = {}

import "./BuyWithConfidenceShoutPanel.vue?vue&type=style&index=0&id=3a2b6e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2b6e1e"]])

export default __exports__